import { useAuth } from '@/hooks/useAuth';
import { theme } from '@/lib/theme';
import { useSidebarStore } from '@/hooks/useSidebarStore';
import { Menu } from 'lucide-react';

interface AdminTopBarProps {
  title?: string;
  subtitle?: string;
}

export default function AdminTopBar({ title, subtitle }: AdminTopBarProps) {
  const { user } = useAuth();
  const { toggleMobile } = useSidebarStore();

  const now = new Date();
  const dateStr = now.toLocaleDateString('es-CO', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <header
      className="h-16 flex items-center justify-between px-4 md:px-6 flex-shrink-0"
      style={{
        backgroundColor: theme.colors.bgSecondary,
        borderBottom: `1px solid ${theme.colors.border}`,
      }}
    >
      {/* Left: mobile hamburger + page title */}
      <div className="flex items-center gap-3">
        {/* Mobile hamburger — opens the sidebar drawer */}
        <button
          onClick={toggleMobile}
          className="md:hidden flex items-center justify-center w-8 h-8 rounded-lg transition-all hover:bg-white/8"
          style={{ color: theme.colors.textSecondary }}
          aria-label="Abrir menú"
        >
          <Menu size={18} />
        </button>

        {title && (
          <div>
            <h1
              className="text-white text-base font-semibold leading-tight"
              style={{ fontFamily: theme.fonts.display }}
            >
              {title}
            </h1>
            {subtitle && (
              <p className="text-xs mt-0.5 capitalize hidden sm:block" style={{ color: theme.colors.textDisabled }}>
                {subtitle}
              </p>
            )}
          </div>
        )}
      </div>

      {/* Right: date + user */}
      <div className="flex items-center gap-5">
        <span className="text-xs hidden md:block capitalize" style={{ color: theme.colors.textDisabled }}>
          {dateStr}
        </span>

        <div className="flex items-center gap-2.5">
          <div
            className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0"
            style={{
              backgroundColor: 'rgba(255,255,255,0.08)',
              border: `1px solid ${theme.colors.border}`,
            }}
          >
            <i className="ri-user-line text-xs" style={{ color: theme.colors.textMuted }} />
          </div>
          <span className="text-sm hidden sm:block" style={{ color: theme.colors.textSecondary }}>
            {user?.email}
          </span>
        </div>
      </div>
    </header>
  );
}
